import { H1Text } from '@prisjakt/ui/text/variants';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from 'src/components/app-context';
import Loader from 'src/components/loader';
import { PageContent } from 'src/components/page';
import { useMatchedRoute } from 'src/hooks/use-matched-route';
import type { KeywordListingPageQuery } from '../../types';
import { NavigationSliceView } from '../product-collection/components/navigation/navigation-component';
import { useKeywordListingPageQuery } from './queries/useKeywordListingPageQuery';
import * as S from './styles';

const KeywordListingPageLoader = () => {
  const route = useMatchedRoute();
  const { data, isLoading, isSuccess } = useKeywordListingPageQuery(
    route?.variables
  );

  return (
    <PageContent>
      {isLoading ? <Loader /> : null}
      {isSuccess ? (
        <KeywordListingPageComponent
          popularSearchTerms={data?.popularSearchTerms}
        />
      ) : null}
    </PageContent>
  );
};

const KeywordListingPageComponent = ({
  popularSearchTerms,
}: Pick<KeywordListingPageQuery, 'popularSearchTerms'>) => {
  const { keywords, categories } = popularSearchTerms ?? {
    keywords: [],
    categories: [],
  };
  const { t } = useAppContext();
  const links = useMemo(
    () =>
      categories.map(({ id, name, url, imageUrl }) => ({
        id,
        value: name,
        path: url,
        imageUrl,
        indexable: true,
        selected: false,
      })),
    [categories]
  );
  const title = useMemo(
    () =>
      categories && categories.length ? (
        <S.Wrapper>
          <H1Text>
            {t('category', 'keyword-listing-page.title', {
              category: (
                <Link to={categories[0].url} key={categories[0].url}>
                  {categories[0].name}
                </Link>
              ),
            })}
          </H1Text>
        </S.Wrapper>
      ) : null,
    [categories, t]
  );
  return (
    <>
      <S.Header>
        {title}
        {links.length ? (
          <NavigationSliceView links={links} onClickPreventDefault={false} />
        ) : null}
      </S.Header>
      <S.Wrapper>
        <S.KeywordList>
          {keywords.map(keyword => (
            <S.KeywordListItem key={keyword.url}>
              <Link to={keyword.url}>{keyword.name}</Link>
            </S.KeywordListItem>
          ))}
        </S.KeywordList>
      </S.Wrapper>
    </>
  );
};

export default KeywordListingPageLoader;
